import * as Types from '@haaretz/s-fragments/Types';


/**
 * -----------------------------------------------------------------------------
 * ⚠️  AUTO-GENERATED FILE - DO NOT EDIT MANUALLY ⚠️
 * -----------------------------------------------------------------------------
 * This file was automatically generated by GraphQL Codegen.
 * Any manual changes will be overwritten.
 * -----------------------------------------------------------------------------
 */

export type UserStatusFragment = (
  { isMailValidated: boolean, isMobileValidated: boolean, miniRegStatus: boolean, isPhoneEmailConn: boolean }
  & { __typename: 'UserStatus' }
);


export type UserStatusFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const UserStatusFragmentGql = `
    fragment UserStatusFragment on UserStatus {
  __typename
  isMailValidated
  isMobileValidated
  miniRegStatus
  isPhoneEmailConn
}
    `;